import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Support } from "~/features-deprecated/support/Support";
import { Facebook, Instagram, Telegram, Tiktok, WeChat } from "~/icons";

const socialMedia = [
  {
    url: "#",
    icon: <Telegram viewBox="0 0 140 140" />,
    alt: "telegram",
  },
  {
    url: "#",
    icon: <WeChat viewBox="0 0 140 140" />,
    alt: "wechat",
  },
  {
    url: "#",
    icon: <Tiktok viewBox="0 0 140 140" />,
    alt: "tiktok",
  },
  {
    url: "#",
    icon: <Instagram viewBox="0 0 140 140" />,
    alt: "tiktok",
  },
  {
    url: "#",
    icon: <Facebook viewBox="0 0 140 140" />,
    alt: "tiktok",
  },
];
export const SupportMedia: FC = () => {
  const { t } = useTranslation("support");
  return (
    <Support title={t("social-media.heading.title")} messengers={socialMedia} />
  );
};
